import useUser from '@/utils/hooks/useUser'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import { useInView } from 'react-intersection-observer'
import Avatar from './Avatar'
import FollowToggleButton from './FollowToggleButton'
import ScreenName from './ScreenName'

export interface UserListProps extends HTMLAttributes<HTMLDivElement> {
	/**
	 * username list
	 */
	data: string[]
	onLoadMore: () => void
}

export default function UserList({ data, onLoadMore, ...props }: UserListProps) {
	const { ref: loadMoreRef } = useInView({
		onChange: (inView) => {
			if (inView) {
				// loadmore
				onLoadMore?.()
			}
		},
	})

	return (
		<div {...props}>
			<div
				css={css`
					> * {
						padding: 16px 0;

						&:not(:first-of-type) {
							border-top: 0.5px solid var(--tint-separator, #dbdbdb);
						}
					}
				`}
			>
				{data.map((username) => (
					<UserListItem key={username} username={username} />
				))}
			</div>
			<div
				ref={loadMoreRef}
				css={css`
					height: 100px;
				`}
			/>
		</div>
	)
}

function UserListItem({ username }: { username: string }) {
	const data = useUser(username)

	if (!data) {
		return null
	}

	return (
		<div
			css={css`
				display: flex;
				gap: 8px;
				align-items: center;
				justify-content: space-between;
			`}
		>
			<div
				css={css`
					display: grid;
					gap: 12px;
					align-items: center;
					grid-template-columns: 44px 1fr;
					overflow: hidden;
				`}
			>
				<Avatar
					data={data}
					css={css`
						width: 44px;
						height: 44px;
					`}
				/>
				<div
					css={css`
						overflow: hidden;
					`}
				>
					<ScreenName data={data} />
					<div
						css={css`
							margin-top: 4px;
							color: var(--tint-secondary, #808080);
							font-size: 14px;
							line-height: 20px;
							letter-spacing: 0.25px;
							height: 20px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						`}
					>
						{data.briefIntro}
					</div>
				</div>
			</div>

			<FollowToggleButton
				data={data}
				size="sm"
				noAddIcon
				css={css`
					&.jk-btn {
						width: 70px;
					}
				`}
			/>
		</div>
	)
}
